import { MongoAbility } from '@casl/ability';

export interface ProfileType {
  givenName?: string;
  surname?: string;
  userPrincipalName?: string;
  id?: string;
  displayName?: string;
  shortName?: string;
  viaUserId?: number;
}

export enum PermissionAction {
  Create = 'Create',
  Add = 'Add',
  Read = 'Read',
  Edit = 'Edit',
  Delete = 'Delete',
  Remove = 'Remove',
  View = 'View',
  Active = 'Active',
  Inactive = 'Inactive',
  AddNote = 'AddNote',
  AddDocumnent = 'AddDocument',
  Upload = 'Upload',
  Download = 'Download',
  AddTask = 'AddTask',
  Complete = 'Complete',
  NotNeeded = 'NotNeeded',
  Generate = 'Generate',
  AddParticipant = 'AddParticipant',
  AddUser = 'AddUser',
  SetasActive = 'SetasActive',
  SetasInactive = 'SetasInactive',
  AddDepartment = 'AddDepartment',
  AddEmployee = 'AddEmployee',
  AddTemplate = 'AddTemplate',
  AddWorkFlow = 'AddWorkFlow',
  Design = 'Design',
  CreateaCopy = 'CreateaCopy',
  AddSubProcess = 'AddSubProcess',
  AddStep = 'AddStep',
  SetDefaultValues = 'SetDefaultValues',
  AddVariable = 'AddVariable',
  ViewRequest = 'ViewRequest',
  ViewResponse = 'ViewResponse',
  DownloadRequest = 'DownloadRequest',
  DownloadResponse = 'DownloadResponse',
  ChangeLog = 'ChangeLog',
  BulkBlock = 'BulkBlock',
  BulkUnblock = 'BulkUnblock',
  ActiveInactive = 'ActiveInactive',
  AddClient = 'AddClient',
  AddTenant = 'AddTenant',
  BulkActive = 'BulkActive',
  BulkInactive = 'BulkInactive',
  Export = 'Export',
  ChangeStatus = 'ChangeStatus',
}

export enum PermissionSubject {
  // modules
  viaCore = 'viaCore',
  viaCMS = 'viaCMS',
  viaWorks = 'viaWorks',
  viaAdmin = 'viaAdmin',
  viaPeople = 'viaPeople',

  MyWorkQueue = 'viaCMS.Dashboard.MyWorkQueue',
  DashboardMyTasks = 'viaCMS.Dashboard.MyTasks',
  MyCalendar = 'viaCMS.Dashboard.MyCalendar',
  MyWorkQueues = 'viaCMS.MyWorkQueues',
  MyTasks = 'viaCMS.MyTasks',
  Case = 'viaCMS.Case',
  ReferralIntake = 'viaCMS.ReferralIntake',
  CaseSearch = 'viaCMS.CaseSearch',
  CaseSteps = 'viaCMS.Case.CaseSteps',
  Notes = 'viaCMS.Case.Notes',
  Documents = 'viaCMS.Case.Documents',
  CaseTasks = 'viaCMS.Case.Tasks',
  Participants = 'viaCMS.Case.Participants',
  ManageParticipants = 'viaCMS.ManageParticipants',
  CaseDesignation = 'viaCMS.ManageParticipants.CaseDesignation',
  Client = 'viaCMS.ManageParticipants.Client',
  CourtDesignation = 'viaCMS.ManageParticipants.CourtDesignation',
  Vendor = 'viaCMS.ManageParticipants.Vendor',
  Plaintiff = 'viaCMS.ManageParticipants.Plaintiff',
  ManageUser = 'viaPeople.ManageUser',
  Dashboard = 'viaPeople.Dashboard',
  DashboardTasks = 'viaPeople.Dashboard.Tasks',
  DashboardQueue = 'viaPeople.Dashboard.Queue',
  DashboardMetrics = 'viaPeople.Dashboard.Metrics',
  DashboardInventoryLog = 'viaPeople.Dashboard.InventoryLog',
  ManageDepartment = 'viaPeople.ManageDepartment',
  EmployeeManagement = 'viaPeople.EmployeeManagement',
  SystemAccess = 'viaPeople.SystemAccess',
  WorkflowComponents = 'viaWorks.WorkflowComponents',
  Designer = 'viaWorks.Designer',
  WorkflowLibrary = 'viaWorks.WorkflowComponents.WorkflowLibrary',
  SubProcessLibrary = 'viaWorks.WorkflowComponents.SubProcessLibrary',
  StepLibrary = 'viaWorks.WorkflowComponents.StepLibrary',
  VariableLibrary = 'viaWorks.VariableLibrary',
  ChecklistLibrary = 'viaWorks.ChecklistLibrary',
  ManageClient = 'viaAdmin.ManageClient',
  ClientManagement = 'viaAdmin.ClientManagement',
  ManageTenant = 'viaAdmin.ManageTenant',
  ManageSelectList = 'viaAdmin.ManageSelectList',
  QueueBuilder = 'viaPeople.QueueBuilder',
}

export type AppAbility = MongoAbility<[PermissionAction, PermissionSubject]>;

export interface AccessibleTenant {
  tenantId: string;
  name: string;
  isCurrentTenant: boolean;
  tenantType: string;
  tenantTypeId: number;
}

export interface UserPermission {
  id: number;
  name: string;
  code: string;
  type?: string;
  moduleId?: number;
  moduleName?: string;
}

export interface UserRole {
  roleId: number;
  userId: number;
  roleName: string;
  permissions: UserPermission[];
}

export interface PermissionModule {
  id: number;
  name: string;
  code: PermissionSubject;
}

export interface UserDetails {
  id: number;
  uniqueId: string;
  email: string;
  firstName: string;
  middleName: any;
  lastName: string;
  isActive: boolean;
  currentTenantId: string;
  accessibleTenants: AccessibleTenant[];
  userRoles: UserRole[];
  modules: PermissionModule[];
}

export type UserDetailsSummary = {
  id: number;
  email: string;
  name: string;
  firstName: string;
  middleName: any;
  lastName: string;
  phoneNumber: any;
  isActive: boolean;
  tenantIds: string[];
  currentTenantName: string;
  accessibleTenantNames: string;
  currentTenantId: string;
};

export type SecurityTemplate = {
  id: number;
  name: string;
  tenantId: string;
  tenantName: string;
  isEditable: boolean;
  statusId: number;
  roleStatus: string;
  numberOfUsers: number;
  permissions: UserPermission[];
};
